import { AxiosResponse } from 'axios';
import environment from '@environment';
import { CacheAreaKey } from 'core/config/cache-config';
import { OnDemandDetailsDTO } from 'core/models/account/on-demand';
import { BoxOfficeHistoryResponseDTO } from 'core/models/product/box-office-history.dto';
import { BoxOfficeRentAMovieRequest, BoxOfficeRentAMovieResponse } from 'core/models/product/on-demand';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { StorageHelper } from 'core/services/storage';
import { SiteConfigStore } from 'core/stores/site-config.store';

export class OnDemandService {
  private static apiBuilder = new EndpointHelper(`${environment.MAH_API_BASE_URL}/${environment.MAH_API_BOXOFFICE}/${environment.MAH_API_VERSION}/BoxOffice`);
  private static utilApiBuilder = new EndpointHelper(`${environment.MAH_EAZY_MOBILE_API_BASE_URL}/BoxOffice`);

  static getBalance(customerNumber: string, country: string): Promise<OnDemandDetailsDTO> {
    const url = this.apiBuilder.createUrl('GetBalance')
      .addQueryParam('Country', country)
      .addQueryParam('CustomerNumber', customerNumber)
      .addQueryParam('BusinessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('Channel', SiteConfigStore.channel())
      .build();

    const storedItems = (StorageHelper<OnDemandDetailsDTO>).GetInstance.getFromCache('req', url, CacheAreaKey.OnDemandDetails);
    if (storedItems) {
      return Promise.resolve(storedItems as OnDemandDetailsDTO);
    }

    return HttpClient.GetInstance.get<OnDemandDetailsDTO>(url)
      .then(
        (res: AxiosResponse<OnDemandDetailsDTO>) => (
          (StorageHelper<OnDemandDetailsDTO>).GetInstance.setCacheAndReturn('req', CacheAreaKey.OnDemandDetails, res?.data, url) as OnDemandDetailsDTO
        )
      )
  }

  static getAmountValues(country: string, customerNumber: string) {
    const url = this.utilApiBuilder.createUrl('GetAmountValues')
      .addQueryParam('customerNumber', customerNumber)
      .addBaseRouteParam(country)
      .build();

    const storedItems = (StorageHelper<{ topUpAmountList: string[] }>).GetInstance.getFromCache('req', url, CacheAreaKey.OnDemandDetails);
    if (storedItems) {
      return Promise.resolve(storedItems as { topUpAmountList: string[] });
    }

    return HttpClient.GetInstance.get<{ topUpAmountList: string[] }>(url)
      .then(
        (res: AxiosResponse<{ topUpAmountList: string[] }>) => (
          (StorageHelper<{ topUpAmountList: string[] }>).GetInstance.setCacheAndReturn('req', CacheAreaKey.OnDemandDetails, res?.data, url) as { topUpAmountList: string[] }
        )
      )
  }

  static rentAMovie(country: string, customerNumber: string, payLoad?: BoxOfficeRentAMovieRequest) {
    const url = this.apiBuilder.createUrl('RentAMovie')
      .addQueryParam('Country', country)
      .addQueryParam('customerNumber', customerNumber)
      .addQueryParam('BusinessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('Channel', SiteConfigStore.channel())
      .build();

    return HttpClient.GetInstance.post<BoxOfficeRentAMovieRequest, BoxOfficeRentAMovieResponse>(url, payLoad)
      .then(res => res?.data)
  }

  static getHistory(country: string, customerNumber: string) {
    // https://qa-api.dstvafrica.com/boxoffice-unifiedapi/api/v1/BoxOffice/GetRentalHistory?Country={Country}&BusinessUnit={BusinessUnit}&Channel={Channel}&CustomerNumber={CustomerNumber}
    const url = this.apiBuilder.createUrl('GetRentalHistory')
      .addQueryParam('country', country)
      .addQueryParam('businessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('customerNumber', customerNumber)
      .addQueryParam('channel', SiteConfigStore.channel())
      .build();


    const storedItems = (StorageHelper<BoxOfficeHistoryResponseDTO>).GetInstance.getFromCache('req', url, CacheAreaKey.OnDemandDetails);
    if (storedItems) {
      return Promise.resolve(storedItems as BoxOfficeHistoryResponseDTO);
    }

    return HttpClient.GetInstance.get<BoxOfficeHistoryResponseDTO>(url)
      .then(
        (res: AxiosResponse<BoxOfficeHistoryResponseDTO>) => (
          (StorageHelper<BoxOfficeHistoryResponseDTO>).GetInstance.setCacheAndReturn('req', CacheAreaKey.OnDemandDetails, res?.data, url)
        )
      )
  }
}